<template>
  <main class="main community" role="main">
    <div class="main_con">
      <div
        class="header_btn color pnt"
        @click="$router.push({ name: 'Board.Mine' })"
      >
        <img
          :src="require(`@/assets/front/images/i_c_document_g.svg`)"
          alt=""
        />
        <p>내 작성 글</p>
      </div>
      <div class="sec_wrap">
        <div class="search_box_wrap">
          <div class="search_box">
            <input
              type="search"
              placeholder="질문 검색"
              v-model="params.keyword"
              @keyup.enter="getList"
            />
            <i class="i_search pnt" @click="getList"></i>
          </div>
        </div>
        <div class="sub_filter_wrap board">
          <div>
            총<span class="error"> {{ boardCnt }}</span
            >개의 검색 결과
          </div>
          <div class="select_box">
            <button @click="openSortModal">
              {{ selectedSort.label }}<i class="i_select_s"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- 게시판 리스트 -->
      <div class="con">
        <ul v-if="boardList.length > 0">
          <li
            class="list_item pnt"
            v-for="item in boardList"
            :key="item.id"
            @click="goDetail(item.id, item.reportCount)"
          >
            <ListItem :board-type="boardType" :data="item" />
          </li>
        </ul>
        <ul v-else>
          <div class="empty_wrap">
            <div class="empty">
              <div class="msg">
                <div>등록된 글이 없습니다</div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <!-- 글쓰기 작성 버튼-->
      <button class="write_btn" @click="fnWrite">
        <i class="i_review_write_w"></i>
        <p>글쓰기</p>
      </button>
      <SortModal
        :value="selectedSort"
        :show="isSortModal"
        @close="cloasSortModal"
      />
    </div>
  </main>
</template>

<script>
import {
  mapActions as communityMapActions,
  mapGetters as communityGetters,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';

import ListItem from '@common/components/community/ListItem';
import SortModal from '@common/components/community/modal/SortModal';

export default {
  name: 'community-board-list',
  description: '커뮤니티 > 자유게시판 리스트',
  components: {
    ListItem,
    SortModal,
  },
  data() {
    return {
      boardType: 'BOARD',
      direction: 'top',
      infiniteId: 0,
      params: {
        page: 1,
        size: 1000,
        myPost: 'N',
        orderType: 'CREATED_AT_DESC',
        keyword: '',
      },
      selectedSort: { label: '최신 순', value: 'CREATED_AT_DESC' },
      isSortModal: false,
      keyword: '',
    };
  },
  created() {
    // 검색 페이지에서 진입시
    this.keyword = this.$route.query.keyword;
    if (this.keyword) this.params.keyword = this.keyword;

    this.getList();
  },
  computed: {
    ...communityGetters({
      boardList: communityTypes.FETCH_BOARD_LIST,
      boardCnt: communityTypes.FETCH_BOARD_CNT,
    }),
  },
  methods: {
    ...communityMapActions([communityTypes.FETCH_BOARD_LIST]),
    async getList() {
      if (this.keyword) {
        this.$router
          .push({
            name: 'Board.List',
            query: { keyword: this.keyword },
          })
          .catch(() => {});
      }
      await this[communityTypes.FETCH_BOARD_LIST](this.params);
    },
    openSortModal() {
      this.isSortModal = true;
    },
    closeSortModal() {
      this.isSortModal = false;
    },
    goDetail(boardId, reportCount) {
      if (reportCount == 0) {
        this.$router.push({
          name: 'Board.Detail',
          params: { id: boardId, isRead: 'Y' },
        });
      }
    },
    fnWrite() {
      this.$router.push({ name: 'Board.Write' });
    },
    cloasSortModal(val) {
      if (val) {
        this.selectedSort = val;
        this.params.orderType = val.value;
        this.getList();
      }
      this.isSortModal = false;
    },
  },
};
</script>

<style></style>
